import React from 'react';
import { IBaseProps } from 'lib/data/interfaces';
import { ComponentTemplate, EntryGroupTemplate, ListingGroupTemplate, MetadataTemplate } from 'lib/data/model';
import { MiniTemplateCard } from 'components/general/TemplateCard';
import { IconType } from 'lib/data/model/dictionaries/IconTypes';
import "./GenericTemplateSelector.less";
import { ComponentNames } from 'lib/data/model/dictionaries/ComponentNames';
import { SectionTemplate } from 'lib/data/model';
import { TemplateSelectorGroup } from './TemplateSelectorGroup';

interface IGenericTemplateSelectorProps extends IBaseProps {
    genericComponentTemplates: ComponentTemplate[];
    selectedMultiItemTemplates: ComponentTemplate[];
    addToNewTemplateList(template): void;
    addToTemplateMultiItemRequirement(index: number, listName: string): void;
}
interface IGenericTemplateSelectorState {

}

const newTemplateTypes = [
    "SectionTemplate",
    "EntryGroupTemplate",
    "ListingGroupTemplate",
];

const createNewTemplate = (addToNewTemplateList, type: "SectionTemplate" | "EntryGroupTemplate" | "ListingGroupTemplate") => {
    let template;
    switch (type) {
        case "SectionTemplate":
            template = new SectionTemplate;
            template.dataTemplate = new MetadataTemplate();
            template.name = "New" + ComponentNames[type]
            break;
        case "EntryGroupTemplate":
            template = new EntryGroupTemplate;
            template.name = "New" + ComponentNames[type]

            break;
        case "ListingGroupTemplate":
            template = new ListingGroupTemplate;
            template.name = "New" + ComponentNames[type]
            break;

        default:
            break;
    }
    addToNewTemplateList(template)
}

export class GenericTemplateSelector extends React.Component<IGenericTemplateSelectorProps, IGenericTemplateSelectorState> {

    constructor(props: IGenericTemplateSelectorProps) {
        super(props);
        this.state = {

        }
    }
    render() {
        return (
            <div className="generic-template-selector">
                <div className="template-selector-group">
                    {newTemplateTypes.map((templateType, key) => <MiniTemplateCard onClick={() => createNewTemplate(this.props.addToNewTemplateList, templateType)} key={key} className={"new-template-mini-cards"} title={`New ${ComponentNames[templateType]}`} iconType={IconType.get(templateType)} />)}
                </div>
                <TemplateSelectorGroup titleBarText="Selected:" componentList={this.props.selectedMultiItemTemplates} highlighted={true} onCardClick={(key) => this.props.addToTemplateMultiItemRequirement(key, "selectedMultiItemTemplates")} />
                <TemplateSelectorGroup titleBarText="Options:" componentList={this.props.genericComponentTemplates} onCardClick={(key) => this.props.addToTemplateMultiItemRequirement(key, "genericComponentTemplates")} />
            </div>
        );
    }
}
